
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"fill":"#2c2c30","stroke":"#707070","d":"M0 0h24v24H0z","transform":"translate(-2081 -1782)"}})])]),_c('g',{attrs:{"fill":"#2c2c30","clip-path":"url(#a)","transform":"translate(2081 1782)"}},[_c('path',{attrs:{"d":"M-2069.711-1763.45h9.091a2.2 2.2 0 001.229-.256.858.858 0 00.353-.745 3.062 3.062 0 00-.426-1.478 5.224 5.224 0 00-1.225-1.447 6.442 6.442 0 00-1.931-1.1 7.244 7.244 0 00-2.545-.422 7.244 7.244 0 00-2.545.422 6.442 6.442 0 00-1.931 1.1 5.224 5.224 0 00-1.225 1.447 3.062 3.062 0 00-.426 1.478.858.858 0 00.353.745 2.2 2.2 0 001.228.256zm4.546-6.742a2.641 2.641 0 001.455-.426 3.13 3.13 0 001.063-1.156 3.365 3.365 0 00.4-1.643 3.194 3.194 0 00-.4-1.593 3.067 3.067 0 00-1.067-1.125 2.7 2.7 0 00-1.451-.415 2.663 2.663 0 00-1.447.418 3.132 3.132 0 00-1.067 1.133 3.192 3.192 0 00-.4 1.6 3.308 3.308 0 00.4 1.628 3.161 3.161 0 001.067 1.156 2.628 2.628 0 001.447.423zm-12.393 6.742h5.475a1.636 1.636 0 01-.288-.991 3.469 3.469 0 01.253-1.229 5.539 5.539 0 011.755-2.336 5.968 5.968 0 00-1.4-.657 5.7 5.7 0 00-1.781-.257 5.829 5.829 0 00-2.211.4 5.424 5.424 0 00-1.677 1.054 4.816 4.816 0 00-1.071 1.424 3.472 3.472 0 00-.372 1.516 1.035 1.035 0 00.3.795 1.482 1.482 0 001.017.281zm4.016-6.58a2.309 2.309 0 001.263-.369 2.71 2.71 0 00.929-1.007 2.921 2.921 0 00.349-1.428 2.782 2.782 0 00-.349-1.394 2.658 2.658 0 00-.929-.978 2.364 2.364 0 00-1.263-.353 2.332 2.332 0 00-1.255.361 2.712 2.712 0 00-.935.982 2.78 2.78 0 00-.353 1.4 2.884 2.884 0 00.353 1.41 2.718 2.718 0 00.929 1 2.309 2.309 0 001.261.375z"}})])])
          )
        }
      }
    